import React from 'react';
import { EdaData } from '../../types'; // Adjust path as needed

interface EdaInsightsProps {
  edaData: EdaData | null;
  currentEdaPath: string;
}

export const EdaInsights: React.FC<EdaInsightsProps> = ({ edaData, currentEdaPath }) => {
  if (!edaData) {
    return <p>Keine EDA Daten zum Anzeigen der Insights vorhanden. Bitte geben Sie einen gültigen Pfad an und laden Sie die Daten.</p>;
  }

  const insights = edaData.eda_results.insights;

  return (
    <div className="eda-insights-container card">
      <h2><span className="icon">👁️</span> EDA Insights für: <span className="path-display">{currentEdaPath}</span></h2>
      {insights && insights.length > 0 ? (
        <ul className="insights-list">
          {insights.map((insight, index) => (
            <li key={index} className={`insight-item severity-${insight.severity.toLowerCase()}`}>
              <strong>{insight.type} ({insight.severity}):</strong> {insight.message}
              {insight.affected_features && (
                <div className="affected-items">Betroffene Features: {insight.affected_features.join(', ')}</div>
              )}
               {insight.affected_target && (
                <div className="affected-items">Betroffenes Target: {insight.affected_target}</div>
              )}
              {/* Optionally display details for correlations */}
              {insight.type === 'correlations' && insight.details && (
                 <ul className="correlation-details">
                    {insight.details.map((corr, corrIdx) => (
                        <li key={corrIdx}>{corr.feature1} &lt;-&gt; {corr.feature2}: {corr.correlation.toFixed(3)} ({corr.strength})</li>
                    ))}
                 </ul>
              )}
            </li>
          ))}
        </ul>
      ) : (
        <p>Keine besonderen Insights in den EDA Ergebnissen gefunden.</p>
      )}
    </div>
  );
}; 